var gst_arr = localStorage.getItem("gst");

if (gst_arr === null) {
    gst_arr = 'false';
}

if (gst_arr === 'true') {
    document.querySelectorAll('.IncGst').forEach(el => el.style.display = 'flex');
    document.querySelectorAll('.ExcGst').forEach(el => el.style.display = 'none');
    document.querySelectorAll('.gst-enabler').forEach(el => el.checked = true);
} else {
    document.querySelectorAll('.IncGst').forEach(el => el.style.display = 'none');
    document.querySelectorAll('.ExcGst').forEach(el => el.style.display = 'flex');
    document.querySelectorAll('.gst-enabler').forEach(el => el.checked = false);
}